<script lang="ts" setup>
import RoomieLoader from '@lahaus-roomie/roomie/src/components/RoomieLoader/index.vue'
import IconLogo from '@lahaus-roomie/roomie/src/assets/icons/lahaus-logo.svg'

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsLoader'
}
</script>

<template>
  <section class="onboarding-steps-loader">
    <IconLogo class="h-32 mx-auto mt-32" />

    <div class="flex justify-center mt-40 mb-16">
      <RoomieLoader
        :loading="true"
        size="md" />
    </div>

    <h2 class="text-carbon-800 text-20 font-semibold mb-8 text-center">
      {{ t('title') }}
    </h2>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
